var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3996 0.365332C13.7501 0.58603 13.8554 1.0491 13.6347 1.39962L6.07913 13.3996C5.95198 13.6016 5.73631 13.7309 5.49828 13.7481C5.26025 13.7652 5.02828 13.668 4.87353 13.4864L0.429082 8.26896C0.160479 7.95365 0.198348 7.48029 0.513665 7.21168C0.828982 6.94308 1.30234 6.98095 1.57095 7.29627L5.35357 11.7367L12.3653 0.600397C12.586 0.249875 13.0491 0.144633 13.3996 0.365332Z",
    fill: "#4B9560"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreen);
export default __webpack_public_path__ + "static/media/CheckmarkGreen.87b274bbd79eae2846855b987319bd22.svg";
export { ForwardRef as ReactComponent };